import type { NBranches } from '@app/types';
import type { NChains } from '@app/types/Chains';

export const adaptBranchToRedux = (
  data: NBranches.ModelBranchLite
): NChains.ChainBranches => {
  const { BranchId, Name, IsSelected } = data;

  const result: NChains.ChainBranches = {
    branchId: BranchId,
    name: Name || '',
    isSelected: IsSelected,
  };

  return result;
};
